export default __webpack_public_path__ + "static/media/skills.687f71f8.svg";